import { registerProduct } from "../../registry/product-registry";
import { disputesProductConfig } from "./tasks";

/**
 * Registers the disputes product config with the setup-guide registry.
 * Import this module once at app shell mount time (Phase 5) — registration
 * happens as a side effect of the import.
 *
 * Wrapped in an init guard so dev-server hot-reloads don't double-register.
 */
let registered = false;

export function registerDisputesProduct(): void {
  if (registered) return;
  registerProduct(disputesProductConfig);
  registered = true;
}
